export const getDescriptionForAWBStatus = (status) => {
  switch (status) {
    case 'ADV':
      return 'Booked';
    case 'DRFT':
      return 'Draft';
    case 'SLI' :
      return 'SLI';
    case 'FOH':
      return 'Freight On Hand';
    case 'MAN':
      return 'Manifested';
    case 'DEP':
      return 'Departed';
    case 'ARR':
      return 'Arrived';
    case 'RCF':
      return 'Received at Facility';
    case 'DLV':
      return 'Delivered';
    case 'DISC':
      return 'Discrepancy';
    case 'CXLD':
      return 'Cancelled';
    case 'DCLS':
      return 'Closed Cancelled';
    case 'VOID':
      return 'Void';
    default:
      return '';
  }
};

export const getCSSForAWBStatus = (status) => {
    switch (status) {
        case 'ARR':
            return 'tracking-details-status-and-service__wrapper tracking-details-status-and-service-background__green';
        case 'CXLD':
            return 'tracking-details-status-and-service__wrapper tracking-details-status-and-service-background__red';
        case 'DISC':
        case 'ADV':
        case 'DRFT':
        case 'SLI':
        case 'FOH':
        case 'MAN':
        case 'DEP':
        case 'RCF':
        case 'DLV':
        case 'DCLS':
        case 'VOID':
        default:
            return 'tracking-details-status-and-service__wrapper tracking-details-status-background__blue';
    }
};



// WEBPACK FOOTER //
// ./src/shared/awbStatus.js